import cs from 'classnames';

import Icon from 'components/shared/Icon/Icon';

const toneClassName = {
  danger: 'text-danger-600',
  orange: 'text-orange-dark-400',
  yellow: 'text-yellow-400',
  primary: 'text-primary-500',
  success: 'text-success-500'
};

const ProgressCircle = ({ percentage = 0, tone, size = 28, className, ariaLabel }) => {
  const strokeWidth = Math.max(3, Math.round(size / 9));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, percentage));
  const isComplete = clamped >= 100;
  const strokeDashoffset = circumference - (clamped / 100) * circumference;
  const progressColor = toneClassName[tone] ?? toneClassName.primary;
  const displayLabel = `${Math.round(clamped)}`;
  const textSizeClass = 'text-[12px] leading-[13px]';
  const shouldRenderProgress = clamped > 0 || isComplete;
  const accessibleLabel =
    ariaLabel || (isComplete ? 'Progress complete' : `${displayLabel}% complete`);
  const svgSize = size - 4;
  const svgOffset = 2;

  return (
    <div
      className={cs(
        'relative flex shrink-0 items-center justify-center rounded-full bg-white',
        className
      )}
      style={{ width: size, height: size }}
      role="img"
      aria-label={accessibleLabel}>
      <svg
        className="absolute"
        style={{ width: svgSize, height: svgSize, top: svgOffset, left: svgOffset }}
        viewBox={`0 0 ${size} ${size}`}
        aria-hidden="true">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          className="text-neutral-200"
          stroke="currentColor"
          fill="none"
        />
        {shouldRenderProgress && (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={`${circumference} ${circumference}`}
            strokeDashoffset={strokeDashoffset}
            className={cs('transition-[stroke-dashoffset] duration-500 ease-out', progressColor)}
            stroke="currentColor"
            fill="none"
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
        )}
      </svg>
      {isComplete ? (
        <Icon icon="check-thick-linear" color="success" size={Math.round(size * 0.55)} />
      ) : (
        <span className={cs('font-600 text-neutral-900', textSizeClass)}>{displayLabel}</span>
      )}
    </div>
  );
};

export default ProgressCircle;
